import { createContext } from "react";

const loadingbarcontext = createContext()

export default loadingbarcontext